export default __webpack_public_path__ + "static/media/044-snow globe.e8b5d376.svg";